export default __webpack_public_path__ + "static/media/backend.911b8160.svg";